var map = {
	"./advance.png": "kzZ7",
	"./bg.png": "uYR6",
	"./header.png": "GUn6",
	"./main-pitch-title1.png": "UDgE",
	"./main-pitch-title2.png": "FhHd",
	"./main-pitch-title3.png": "J959",
	"./main-pitch-title4.png": "cQek",
	"./main-title1.png": "ZZFH",
	"./main-title2.png": "HmSm",
	"./main-title3.png": "fqe9",
	"./main-title4.png": "YG8i",
	"./research-title.png": "IMN3",
	"./text-bg.png": "U0Av",
	"./title-bg.png": "/juG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S58E";


//////////////////
// WEBPACK FOOTER
// ./src/components/researchSystem/images ^\.\/.*$
// module id = S58E
// module chunks = 0